import styled from 'styled-components';

const CloseButton = styled.div`
  margin: 10px 10px 0 0;
  float: right;
  cursor: pointer;
`;

export default CloseButton;
